import gql from 'graphql-tag';

export const CREATE_STAGE_NOTE = gql`
  mutation CreateStageNote($input: CreateStageNoteInput!) {
    bpf {
      result: createStageNote(input: $input) {
        error
        success
        entity {
          id
          stageId
          content
          parentId
          parentType
          createdById
          createdDateTime
          modifiedDateTime
          createdBy {
            id
            fullName
          }
        }
      }
    }
  }
`;
